exelare_jobs.define('main_jobs',[], function () {
    return function ($, ko, root) {
        //loading job list template
        $.get(root.ExelareSettings.mapPathOf("jobListingTemplate"), function (html) {
            root.container.html('');
            root.container.append(html);
            require(["widgets/ShareThisLoader"], function () { });

            var jobsList = new root.JobListModel({ companyId: root.ExelareSettings.curCompanyId, userId: root.ExelareSettings.curUserId, jobId: root.args.viewJob, pwd: root.ExelareSettings.curPwd });

            ko.applyBindings(jobsList, $('#jobsList')[0]);

            //loading job detail template
            $.get(root.ExelareSettings.mapPathOf("jobDetailTemplate"), function (html) {
                root.container.append(html);
            });
            
            //loading application form template
            $.get(root.ExelareSettings.mapPathOf("applicationFormTemplate"), function (html) {
                root.container.append(html);
                //console.log(root);
                root.appForm = new AppFormModel(null);

                appForm.initializeValidator();
                ko.applyBindings(root.appForm, $('#appFormModal')[0]);
            })
        })
        
    }
});

